import { render, staticRenderFns } from "./ComparisonReportTableFooter.vue?vue&type=template&id=19af13d0&"
import script from "./ComparisonReportTableFooter.vue?vue&type=script&lang=js&"
export * from "./ComparisonReportTableFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports